export default "__VITE_ASSET__DxczNWtB__"